<div class="resend-emails-wrapper">
    <div class="text-wrapper">
      {{data | translate}}
    </div>
    <div class="actions-wrapper">
      <app-button width="100" (clickEvent)="onClose(true)" type=stroked [buttonColorType]="'primary'" [isNew]="true">{{'Yes' | translate}}</app-button>
      <app-button width="100" (clickEvent)="onClose(false)" type=stroked [buttonColorType]="'warn'" [isNew]="true">{{'No' | translate}}</app-button>
    </div>
</div>
  